import React from "react";
import {Navigate, Outlet} from "react-router-dom";

const PrivateRoute = () => {
    return !!localStorage.getItem("authenticated_user") && !!localStorage.getItem("authenticated_token") ? <Outlet/> :
        <Navigate exact to={`${process.env.PUBLIC_URL}/login`}/>;
};

export default PrivateRoute;
